import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const MemberTableRow = ({ 
  member, 
  isSelected, 
  onSelect, 
  onEdit, 
  onDelete,
  onViewDetails 
}) => {
  const navigate = useNavigate();

  const handleRowClick = (e) => {
    // Don't navigate if clicking on action buttons or checkbox
    if (e?.target?.closest('button') || e?.target?.closest('[role="checkbox"]')) {
      return;
    }
    navigate('/member-details', { state: { memberId: member?.id } });
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { bg: 'bg-success', text: 'text-success-foreground', label: 'Active' },
      inactive: { bg: 'bg-muted', text: 'text-muted-foreground', label: 'Inactive' },
      pending: { bg: 'bg-warning', text: 'text-warning-foreground', label: 'Pending' },
      suspended: { bg: 'bg-error', text: 'text-error-foreground', label: 'Suspended' }
    };

    const config = statusConfig?.[status] || statusConfig?.inactive;
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config?.bg} ${config?.text}`}>
        {config?.label}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <tr 
      className="border-b border-border hover:bg-muted/50 cursor-pointer transition-colors duration-200"
      onClick={handleRowClick}
    >
      <td className="px-4 py-3">
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(member?.id, e?.target?.checked)}
          onClick={(e) => e?.stopPropagation()}
        />
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <span className="text-xs font-medium text-primary-foreground">
              {member?.name?.split(' ')?.map(n => n?.[0])?.join('')?.substring(0, 2)}
            </span>
          </div>
          <div>
            <div className="font-medium text-foreground">{member?.name}</div>
            <div className="text-sm text-muted-foreground">{member?.email}</div>
          </div>
        </div>
      </td>
      <td className="px-4 py-3 text-sm text-foreground font-mono">{member?.cpf}</td>
      <td className="px-4 py-3 text-sm text-foreground font-mono">{member?.voterId}</td>
      <td className="px-4 py-3 text-sm text-foreground">{member?.region}</td>
      <td className="px-4 py-3 text-sm text-muted-foreground">{formatDate(member?.registrationDate)}</td>
      <td className="px-4 py-3">{getStatusBadge(member?.status)}</td>
      <td className="px-4 py-3">
        <div className="flex items-center space-x-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e?.stopPropagation();
              onViewDetails(member);
            }}
            className="h-8 w-8"
          >
            <Icon name="Eye" size={16} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e?.stopPropagation();
              onEdit(member);
            }}
            className="h-8 w-8"
          >
            <Icon name="Edit" size={16} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e?.stopPropagation();
              onDelete(member);
            }}
            className="h-8 w-8 text-error hover:text-error hover:bg-error/10"
          >
            <Icon name="Trash2" size={16} />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default MemberTableRow;